import videoloop1D from '../../assets/s1D.mp4';
import videoloop1M from '../../assets/s1M.mp4';
import videoloop2D from '../../assets/s2D.mp4';
import videoloop2M from '../../assets/s2M.mp4';
import videoloop3D from '../../assets/v1-l.mp4';
import videoloop3M from '../../assets/v1-s.mp4';
import videoloop4D from '../../assets/v3D.mp4';
import videoloop4M from '../../assets/v3M.mp4';
import videoloop5D from '../../assets/v2D.mp4';
import videoloop5M from '../../assets/v2M.mp4';

export const contentData = [
  {
    title: 'Forging the future alongside AI',
    content: 'eigen',
    body:
      'For well over a century, manufacturing at scale came with some measure of unavoidable defects and loss. But Intel and Eigen are rewriting this equation with AI and computer vision.',
    url: 'https://sponsorcontent.cnn.com/interactive/intel/forging-the-future-alongside-ai/',
    button: 'Watch Video',
    videoS: videoloop5M,
    videoL: videoloop5D
  },
  {
    title: 'Accelerating Science at Scale with Intel AI',
    content: 'argonne',
    body:
      'When tackling problems of unprecedented scale and complexity, the need for tools with unrivaled speed and power is often required. Meet Aurora, one of the fastest supercomputers on the planet, built by Intel, Hewlett Packard Enterprise, and Argonne National Laboratory.',
    url: 'https://sponsorcontent.cnn.com/interactive/intel/accelerating-science-with-ai/',
    button: 'Watch Video',
    videoS: videoloop4M,
    videoL: videoloop4D
  },
  {
    title: 'Neuroscience-Based AI Meets Gaming',
    content: 'game',
    body:
      'The future of AI lies in training it to think as the human mind does. Bay Area software developer Numenta is using neuroscience to leverage Intel AI in new ways, including a powerful new game created by Gallium Studios—founded by Will Wright.',
    url: 'https://sponsorcontent.cnn.com/interactive/intel/neuroscience-ai-and-gaming/',
    button: 'Watch Video',
    videoS: videoloop3M,
    videoL: videoloop3D
  },
  {
    title: 'AI With Purpose',
    content: 'ai-with-purpose',
    body:
      'Around the world, innovators from all walks of life are using AI to solve some of humanity’s biggest problems. Discover how Intel AI solutions such as Federated Learning, OpenVINO, and the Assistive Context-Aware Toolkit are resulting in giant leaps forward in everything from cancer research to crop health.',
    url: 'https://sponsorcontent.cnn.com/interactive/intel/ai-with-purpose/',
    button: 'Watch Video',
    videoS: videoloop1M,
    videoL: videoloop1D
  },
  {
    title: 'The Revolution Happening Under The Hood',
    content: 'auto',
    body:
      'For the past century, cars have been built around the engine and drivetrain. But as automakers greet a silicon revolution, vehicle architecture must be fundamentally redesigned for a new generation of cars that are smarter, safer, and fully electric. Learn how Intel’s decades of innovation in the automotive space are helping automakers prepare for the road ahead.',
    url: 'https://sponsorcontent.cnn.com/interactive/intel/auto/',
    button: 'Read Article',
    videoS: videoloop2M,
    videoL: videoloop2D
  }
];
